import React from 'react';
import moment from 'moment';
import { DateFormat, ParticipantActionViewModel } from 'stageclip-common';

import { AppTable, AppTableColumn } from 'components/table/appTable';
import styles from './ParticipantActionsLog.module.scss';
import Button from 'components/buttons/button';
import { ParticipantActionsLogProps } from './ParticipantActionsLog.types';

export const ParticipantActionsLog = (props: ParticipantActionsLogProps) => {
  const columns: AppTableColumn[] = [
    {
      Header: 'Action',
      accessor: ({ action }: ParticipantActionViewModel) => action,
      id: 'action',
    },
    {
      Header: 'User',
      accessor: ({ user }: ParticipantActionViewModel) => (user ? `${user.firstName} ${user.lastName}` : 'auto'),
      id: 'user',
    },
    {
      Header: 'Timestamp',
      accessor: ({ timestamp }: ParticipantActionViewModel) => moment(timestamp).format(DateFormat.DateTime),
      id: 'timestamp',
    },
    {
      Cell: ({ value }: { value: ParticipantActionViewModel }) => {
        const { data, action, timestamp } = value;

        return data ? <Button onClick={() => props.openDetails({ data, action, timestamp })} text="Details" /> : '-';
      },
      Header: 'Details',
      accessor: (event: ParticipantActionViewModel) => event,
      id: 'details',
    },
  ];

  const { data } = props;

  return (
    <div className={styles.wrapper}>
      <AppTable columns={columns} data={data} />
    </div>
  );
};
